import { Component, OnInit, Input } from '@angular/core';
import  { GridColumnDefinition } from './grid'

@Component({
  selector: 'app-dynamic-grid',
  template: `<div class="ibox-content">
  <div class="ibox-table">
      <div class="table-responsive">
          <table class="responsive-table table-striped table-bordered table-hover">
              <thead>
                  <tr>
                      <th *ngFor="let header of columns" [ngStyle]="{'width': header.width}">
                          <span>
                              {{header.caption}}
                          </span>
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let s of _source">
                      <td *ngFor="let cols of columns" [ngSwitch]="cols.dataType" [ngStyle]="{'width': cols.width}">
                          <span *ngSwitchCase="0">
                              {{s[cols.dataField]}}
                          </span>
                          <span *ngSwitchCase="1">
                              {{s[cols.dataField]}}
                          </span>
                          <span *ngSwitchCase="2">
                              {{s[cols.dataField] | date:"fullDate"}}
                          </span>
                          <span *ngSwitchCase="3">
                              {{s[cols.dataField]}}
                          </span>
                          <span *ngSwitchCase="4">
                              {{s[cols.dataField]}}
                          </span>
                      </td>
                      <td>
                          <input type="button" value="View" (click) = "viewDatRow()" />
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</div>`,
  styles: [``]
})
export class DynamicGridComponent implements OnInit {

  _source: Array<any> = new Array<any>();  
  
    @Input() public columns: Array<GridColumnDefinition> = new Array<GridColumnDefinition>();  
  
    constructor() { }  
  
    ngOnInit(): void {  
        if (this.columns == null || this.columns == undefined || this.columns.length > 0) {  
            console.log("Column Definition of grid not provided.");  
            return;  
        }  
    }  
  
    public bindData(data: Array<any>): void {  
        if (data != null && data != undefined) {              
            this._source = data;              
            console.log('Inside Grid Component Data Source : ' + this._source);
        }  
    } 
    
    
  
    public clearGrid(): void {  
        this._source = [];  
    }  

}
